import "./App.css";
import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Shop from "./components/Shop";
import SingleProduct from "./components/SingleProduct";
import NotFound from "./components/NotFound";
import Checkout from "./components/Checkout";
import OrderSuccess from "./components/OrderSuccess";
import TrackOrder from "./components/TrackOrder";

function App() {
  return (
    <>
      <BrowserRouter>
        <div id="qodef-page-wrapper" className="">
          <Header />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/products" element={<Shop />} />
            <Route
              path="/product/:productId/:name"
              element={<SingleProduct />}
            />
            <Route path="/Checkout/:id" element={<Checkout />} />
            <Route path="/Order-Success/:oid" element={<OrderSuccess />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Footer />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
